import * as React from 'react'

export interface IDrillDownFilterShellContext {
  close: () => void
}

const DrillDownFilterShellContext =
  React.createContext<IDrillDownFilterShellContext>({
    close: () => undefined,
  })

export const DrillDownFilterShellProvider = DrillDownFilterShellContext.Provider

export function useDrillDownFilterShell(): IDrillDownFilterShellContext {
  return React.useContext(DrillDownFilterShellContext)
}
